import { Box, Button, Flex, SimpleGrid } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ProductDetailsDrawer from 'src/components/ProductDetailsDrawer/ProductDetailsDrawer'
import useVisibilityState from 'src/hooks/useVisibilityState'
import { Product } from 'src/types/types'
import { ProductCard } from './ProductCard'

export interface ProductListProps {
  products: Product[]
  loadMore: () => void
  hasNextPage: boolean
  isFetchingNextPage: boolean
  isWastePortal?: boolean
  isUnregisteredUserOnWastePortal?: boolean
}

const ProductList: React.FC<ProductListProps> = ({
  products,
  loadMore,
  hasNextPage,
  isFetchingNextPage,
  isWastePortal = false,
  isUnregisteredUserOnWastePortal = false,
}) => {
  const { t } = useTranslation()
  const [isDrawerVisible, showDrawer, hideDrawer] = useVisibilityState()
  const [selectedProduct, setSelectedProduct] = React.useState<Product | undefined>(undefined)

  const onShowDetails = (product: Product) => {
    showDrawer()
    setSelectedProduct(product)
  }

  const renderProduct = (product: Product) => {
    return <ProductCard
      key={product.id}
      product={product}
      onShowDetails={onShowDetails}
      isWastePortal={isWastePortal}
      isUnregisteredUserOnWastePortal={isUnregisteredUserOnWastePortal}
    />
  }

  if (!products.length) {
    return (
      <Flex alignItems='center' justifyContent='center' flexDirection='column'>
        <Box fontSize='xl' mb={4}>
          {t('products.noProductsFound')}
        </Box>
        <Box fontSize='md' color='gray.500'>
          {t('products.tryDifferentFilters')}
        </Box>
      </Flex>
    )
  }

  return (
    <Box>
      <SimpleGrid columns={{ sm: 1, md: 2 }} spacing='20px' marginBottom='2rem'>
        {products.map(renderProduct)}
      </SimpleGrid>
      {hasNextPage && (
        <Box textAlign='center' mt={4}>
          <Button
            onClick={loadMore}
            isLoading={isFetchingNextPage}
            colorScheme='teal'
            variant='outline'
          >
            {t('products.loadMore')}
          </Button>
        </Box>
      )}
      <ProductDetailsDrawer
        isDrawerVisible={isDrawerVisible}
        hideDrawer={hideDrawer}
        product={selectedProduct}
      />
    </Box>
  )
}

export default ProductList
